var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9272 6.4395C14.8917 6.3581 14.8419 6.28369 14.7803 6.21975L10.2802 1.71975C10.2163 1.65809 10.1419 1.60831 10.0605 1.57275C10.038 1.56225 10.014 1.55625 9.99 1.548C9.92725 1.52664 9.86192 1.51378 9.79575 1.50975C9.78 1.50825 9.76575 1.5 9.75 1.5H4.5C3.67275 1.5 3 2.17275 3 3V15C3 15.8273 3.67275 16.5 4.5 16.5H13.5C14.3273 16.5 15 15.8273 15 15V6.75C15 6.73425 14.9917 6.72 14.9902 6.7035C14.9866 6.63729 14.9737 6.57191 14.952 6.50925C14.9445 6.48525 14.9377 6.462 14.9272 6.4395ZM12.4395 6H10.5V4.0605L12.4395 6ZM4.5 15V3H9V6.75C9 6.94891 9.07902 7.13968 9.21967 7.28033C9.36032 7.42098 9.55109 7.5 9.75 7.5H13.5L13.5015 15H4.5Z",
    fill: "#7A5AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H12V10.5H6V9ZM6 12H12V13.5H6V12ZM6 6H7.5V7.5H6V6Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.79d470e5d09a6652217853f20240fd21.svg";
export { ForwardRef as ReactComponent };